const initialstate = {
    users: [],
    Total:'',
    report_data:''
  };

  export const report_user = (state = initialstate, { type, payload }) => {
    // console.log(payload)
    // console.log('payload')
  
    switch (type) {
      case "GET_REPORT_USER": {
        return {
          ...state,
          users: payload.results,
          Total:payload.Total
        };
      }
      
      default: {
        return { ...state };
      }
    }
  };